<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button
    #backButton
    [project]="project"
    [floorplanGroup]="FloorplanMenuType.MONITORING_CENTRAL_STATION"
  >
  </app-configuration-wizard-back-button>
  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@centralStationConfiguration.wizard.family">Family</odx-wizard-step>
    @if (hasFamilyVariantStep) {
      <odx-wizard-step i18n="@@centralStationConfiguration.wizard.variant">Variant</odx-wizard-step>
    }
    @if (hasLicenceStep) {
      <odx-wizard-step i18n="@@centralStationConfiguration.wizard.step1">Licence</odx-wizard-step>
    }
    @if (hasAdditionalLicencesStep) {
      <odx-wizard-step i18n="@@centralStationConfiguration.wizard.step2">Additional licences</odx-wizard-step>
    }
    @if (hasAccessoriesStep) {
      <odx-wizard-step i18n="@@centralStationConfiguration.wizard.step3">Accessories</odx-wizard-step>
    }
    <odx-wizard-step i18n="@@centralStationConfiguration.wizard.step4">Summary</odx-wizard-step>
  </odx-wizard>

  <app-product-family-selector
    class="w-100"
    [hidden]="activeStep !== 0"
    [title]="CentralStationsSelectorTitleKeyMap[CentralStationsSelectorType.FAMILY]"
    [originalFamily]="originalConfiguration ?? MonitoringCategory.CENTRAL_STATIONS"
    [category]="MonitoringCategory.CENTRAL_STATIONS"
    [categoryLabel]="overviewCategoryLabelMap[CentralStationsSelectorType.FAMILY]"
    (familySelect$)="setSelectedFamily($event)"
    (formReady)="selectedFamilyForm = $event"
  ></app-product-family-selector>

  @if (family; as currentFamily) {
    @if (hasFamilyVariantStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== familyVariantStepIndex"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalFamilyVariantOptions"
        [title]="CentralStationsSelectorTitleKeyMap[CentralStationsSelectorType.FAMILY]"
        [step]="familyVariantStep"
        [category]="MonitoringCategory.CENTRAL_STATIONS"
        [categoryLabel]="overviewCategoryLabelMap[CentralStationsSelectorType.FAMILY]"
        (optionsSelect$)="setSelectedFamilyVariant($event)"
        (formReady)="selectedFamilyVariantForm = $event"
      ></app-option-selector>
    }

    @if (hasLicenceStep) {
      <app-central-station-licence-selector
        class="w-100"
        [hidden]="activeStep !== licenceStepIndex"
        [title]="CentralStationsSelectorTitleKeyMap[CentralStationsSelectorType.LICENCE]"
        [step]="licenceStep"
        [category]="MonitoringCategory.CENTRAL_STATIONS"
        [categoryLabel]="overviewCategoryLabelMap[CentralStationsSelectorType.LICENCE]"
        [familyName]="family.familyName"
        [originalOption]="originalConfiguration?.licence"
        (licenceSelect)="setSelectedLicence($event)"
        (formReady)="licenceForm = $event"
      >
      </app-central-station-licence-selector>
    }

    @if (hasAdditionalLicencesStep) {
      <app-central-station-option-selector
        class="w-100"
        [hidden]="activeStep !== additionalLicencesStepIndex"
        [title]="CentralStationsSelectorTitleKeyMap[CentralStationsSelectorType.ADDITIONAL_LICENCES]"
        [options]="additionalLicenceOptions"
        [category]="MonitoringCategory.CENTRAL_STATIONS"
        [categoryLabel]="overviewCategoryLabelMap[CentralStationsSelectorType.ADDITIONAL_LICENCES]"
        [familyName]="family.familyName"
        [preselectedOptions]="originalConfiguration?.additionalLicences"
        (selectionChange)="updateAdditionalLicences($event)"
      >
      </app-central-station-option-selector>

      <app-central-station-option-selector
        class="w-100"
        [hidden]="activeStep !== accessoriesStepIndex"
        [title]="CentralStationsSelectorTitleKeyMap[CentralStationsSelectorType.ACCESSORIES]"
        [options]="accessoryOptions"
        [category]="MonitoringCategory.CENTRAL_STATIONS"
        [categoryLabel]="overviewCategoryLabelMap[CentralStationsSelectorType.ACCESSORIES]"
        [familyName]="family.familyName"
        [binaryHeader]="accessoriesSingleHeader"
        [quantityHeader]="accessoriesQuantityHeader"
        [preselectedOptions]="originalConfiguration?.accessories"
        (selectionChange)="updateAccessories($event)"
      >
      </app-central-station-option-selector>
    }
  }

  @if (activeStep === summaryStepIndex) {
    <app-monitoring-overview
      class="w-100"
      [title]="CentralStationsSelectorTitleKeyMap[CentralStationsSelectorType.OVERVIEW]"
      [sections]="groupedSections"
      [showCategory]="true"
    ></app-monitoring-overview>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="activeStep"
    [steps]="steps"
  >
  </app-product-config-stepper-bar>
</div>
